import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import { Actions } from 'mailup-web-components'

import type { GroupItem, GroupOperation } from 'Pages/GroupsList/model'

interface ItemActionsProps {
  item: GroupItem
  onEmailSubscribers: (idGroup: number) => void
  onSMSSubscribers: (idGroup: number) => void
  onGroupEdit: (idGroup: number) => Promise<void>
  onGroupDelete: ({
    groups,
    op,
  }: {
    groups: GroupItem[]
    op: GroupOperation
  }) => Promise<void>
  onCopyToList: (group: GroupItem) => Promise<void>
}

const ItemActions: FC<ItemActionsProps> = ({
  item,
  onEmailSubscribers,
  onSMSSubscribers,
  onGroupEdit,
  onGroupDelete,
  onCopyToList,
}) => {
  const intl = useIntl()

  const items = [
    ...(item.Deleteable
      ? [
          {
            label: intl.formatMessage({
              id: 'Load.MailupCommon.Edit',
            }),
            value: item.Id,
            onClick: onGroupEdit,
          },
        ]
      : []),
    {
      label: intl.formatMessage({ id: 'Load.GroupsList.ActionCopyToList' }),
      value: item,
      onClick: onCopyToList,
    },
    {
      label: intl.formatMessage({ id: 'Load.Common.EmailSubscribers' }),
      value: item.Id,
      onClick: onEmailSubscribers,
    },
    {
      label: intl.formatMessage({ id: 'Load.Common.SmsSubscribers' }),
      value: item.Id,
      onClick: onSMSSubscribers,
    },

    ...(item.Deleteable
      ? [
          {
            label: intl.formatMessage({
              id: 'Load.GroupsList.ActionDeleteGroup',
            }),
            value: { groups: [item], op: 'DeleteGroup' },
            onClick: onGroupDelete,
            separator: true,
          },
          {
            label: intl.formatMessage({
              id: 'Load.GroupsList.ActionDeleteRecipients',
            }),
            value: { groups: [item], op: 'DeleteRecipients' },
            onClick: onGroupDelete,
          },
          {
            label: intl.formatMessage({
              id: 'Load.GroupsList.ActionDeleteGroupAndRecipients',
            }),
            value: { groups: [item], op: 'DeleteGroupAndRecipients' },
            onClick: onGroupDelete,
          },
        ]
      : []),
    {
      label: intl.formatMessage({ id: 'Load.GroupsList.ActionEmptyGroup' }),
      value: { groups: [item], op: 'EmptyGroup' },
      onClick: onGroupDelete,
      separator: !item.Deleteable,
    },
  ]

  return <Actions items={items} />
}

export default ItemActions
